import {
  getBackendClient,
  unwrapApiResponse,
  type ApiSchema,
  type BackendClientOptions,
} from './client'
import type { paths } from './openapi'

export type Customer = ApiSchema<'GetCustomer'>
export type CustomerPlanWire = ApiSchema<'GetCustomerPlan'>
export type CustomerTeamWorkflowSettingsWire = ApiSchema<'GetCustomerTeamWorkflowSettings'>
export type CustomerListPage = ApiSchema<'Page_GetCustomer_'>
export type ListCustomersParams = NonNullable<
  paths['/customers']['get']['parameters']['query']
>

export async function listCustomers(
  query: ListCustomersParams = {},
  options: BackendClientOptions = {},
): Promise<CustomerListPage> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.GET('/customers', {
    params: { query },
  }))
}

export async function getCustomer(
  customerId: string,
  options: BackendClientOptions = {},
): Promise<Customer> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.GET('/customers/{customer_id}', {
    params: { path: { customer_id: customerId } },
  }))
}

export async function getCustomerPlan(
  customerId: string,
  options: BackendClientOptions = {},
): Promise<CustomerPlanWire> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.GET('/customers/{customer_id}/plan', {
    params: { path: { customer_id: customerId } },
  }))
}

export async function getCustomerTeamWorkflowSettings(
  customerId: string,
  options: BackendClientOptions = {},
): Promise<CustomerTeamWorkflowSettingsWire> {
  const client = getBackendClient(options)
  return unwrapApiResponse(
    client.GET('/customers/{customer_id}/team-workflow-settings', {
      params: { path: { customer_id: customerId } },
    }),
  )
}

export type CustomerPolicy = ApiSchema<'GetCustomerPolicy'>
export type PutCustomerPolicy = ApiSchema<'PutCustomerPolicy'>

export async function getCustomerPolicy(
  customerId: string,
  options: BackendClientOptions = {},
): Promise<CustomerPolicy> {
  const client = getBackendClient(options)
  return unwrapApiResponse(
    client.GET('/customers/{customer_id}/policy', {
      params: { path: { customer_id: customerId } },
    }),
  )
}

export async function putCustomerPolicy(
  customerId: string,
  body: PutCustomerPolicy,
  options: BackendClientOptions = {},
): Promise<CustomerPolicy> {
  const client = getBackendClient(options)
  return unwrapApiResponse(
    client.PUT('/customers/{customer_id}/policy', {
      params: { path: { customer_id: customerId } },
      body,
    }),
  )
}
